import React from 'react';
import { connect } from 'react-redux';
import { hashHistory, Link } from 'react-router';
import { Helmet } from 'react-helmet';
import ReactTable from 'react-table';
import Dropzone from 'react-dropzone';
import classNames from 'classnames';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import EventForm from '../components/EventForm';
import ClientLocationsForm from '../components/ClientLocationsForm';
import { isStaff, isExecutive } from '../../../store/current-user/CurrentUserSelectors';
import { requestMeetingTypes } from '../../../store/meeting-types/MeetingTypesActions';
import { requestEscalationTypes } from '../../../store/escalation-types/EscalationTypesActions';
import {
  requestClientEscalations,
  deleteClientEscalation,
} from '../../../store/escalation-manager/EscalationManagerActions';
import { requestClientContacts } from '../../../store/contact-manager/ContactManagerActions';
import { BigBreadcrumbs, WidgetGrid } from '../../../components';
import Comments from '../components/Comments';
import CommentForm from '../components/CommentForm';
import {
  requestClient,
  requestClientFiles,
  uploadClientFiles,
  getClientFile,
  updateClientFileDescription,
  deleteClientFile,
  previewFile,
  requestClientReportCategories
} from '../../../store/client-manager/ClientManagerActions';
import {
  requestClientComments,
  addClientComment,
  updateClientComment,
  deleteClientComment,
} from '../../../store/comments/CommentsActions';
import { requestUserInfo } from '../../../store/current-user/CurrentUserActions';
import Moment from '../../../components/utils/Moment';
import { humanFileSize } from '../../../components/utils/format';
import {
  requestEvents,
  requestEvent,
  updateEvent,
  deleteEvent,
} from '../../../store/event-manager/EventManagerActions';
import { requestUsersTypeahead } from '../../../store/users/UsersActions';
import {
  requestClientLocations,
  requestClientLocation,
  updateClientLocation,
} from '../../../store/client-location-manager/ClientLocationManagerActions';
import FileViewer from 'react-file-viewer';
import { hostTitle } from '../../../config/ui';

class ClientManagerDetail extends React.Component {
  constructor() {
    super();
    this.state = {
      files: [],
      showUpload: false,
      showForm: false,
      showLocationForm: false,
      showPreview: false,
      fileName: null,
      fileType: null,
    };
    this.removeFileFromUploadList = this.removeFileFromUploadList.bind(this);
    this.renderEditable = this.renderEditable.bind(this);
    this.renderEditableTags = this.renderEditableTags.bind(this);
    this.renderEditableCategory = this.renderEditableCategory.bind(this);
    this.renderEditableShared = this.renderEditableShared.bind(this);
  }

  componentWillMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.params.employerCodeNumber !==
      prevProps.params.employerCodeNumber
    ) {
      this.loadData();
    }
  }

  loadData() {
    this.props.getClient(this.props.params.employerCodeNumber, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getComments(this.props.params.employerCodeNumber, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getFiles(this.props.params.employerCodeNumber, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getClientReportCategories({
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getCurrentUser();
    this.props.getMeetingTypes({
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getEscalationTypes({
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getEvents(this.props.params.employerCodeNumber, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getEscalations(this.props.params.employerCodeNumber, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getClientLocations(this.props.params.employerCodeNumber, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getContacts(this.props.params.employerCodeNumber, {
      tenantId: this.props.user.queryParams.tenantId,
    });
  }

  searchUsers = (search, filters = '') => {
    return this.props
      .getUsersTypeahead({
        offset: 0,
        limit: 500,
        order: '',
        search,
        filters,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data && result.payload.data.list) {
          result.payload.data.list.forEach((item) =>
            options.push({
              id: item.id,
              name: `${item.firstName} ${item.lastName}`,
            }),
          );
        }
        return options;
      });
  };

  onSubmit = (parentId, message) => {
    this.props
      .addMessage(message, {
        tenantId: this.props.user.queryParams.tenantId,
        parentId: parentId,
        employerCodeNumber: this.props.params.employerCodeNumber,
      })
      .then(() =>
        this.props.getComments(this.props.params.employerCodeNumber, {
          tenantId: this.props.user.queryParams.tenantId,
        }),
      );
  };

  onUpdateSubmit = (id, message) => {
    this.props
      .updateMessage(id, message, {
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then(() =>
        this.props.getComments(this.props.params.employerCodeNumber, {
          tenantId: this.props.user.queryParams.tenantId,
        }),
      );
  };

  onDeleteSubmit = (id) => {
    this.props
      .deleteMessage(id, {
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then(() =>
        this.props.getComments(this.props.params.employerCodeNumber, {
          tenantId: this.props.user.queryParams.tenantId,
        }),
      );
  };

  editClient = (employerCodeNumber) => {
    hashHistory.push(`/client-manager/client/${employerCodeNumber}`);
  };

  onDrop(files) {
    const filesToAdd = _.difference(files, this.state.files);
    this.setState({ files: this.state.files.concat(filesToAdd) });
  }

  onCancel() {
    this.setState({
      files: [],
    });
  }

  showModal() {
    this.setState({ showUpload: true });
  }

  closeModal() {
    this.setState({ showUpload: false });
    this.onCancel();
  }

  showEventForm = (meetingId) => {
    this.setState({ showForm: true });
    this.props.getEvent(meetingId, {
      tenantId: this.props.user.queryParams.tenantId,
    });
  };

  showLocationForm = (clientLocationId) => {
    this.setState({ showLocationForm: true });
    this.props.getClientLocation(clientLocationId, {
      tenantId: this.props.user.queryParams.tenantId,
    });
  };

  closeLocationForm() {
    this.setState({ showLocationForm: false });
  }

  onLocationFormSubmit = (values) => {
    this.props
      .updateClientLocation(values, {
        tenantId: this.props.user.queryParams.tenantId,
        employerCodeNumber: this.props.params.employerCodeNumber,
      })
      .then((result) => {
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        } else {
          toast.success('Location has been saved.');
          this.setState({ showLocationForm: false });
          this.props.getClientLocations(this.props.params.employerCodeNumber, {
            tenantId: this.props.user.queryParams.tenantId,
          });
        }
      });
  };

  showEscalationForm = (escalationId, employerCodeNumber) => {
    hashHistory.push(
      `/client-manager/escalation/${escalationId}/${employerCodeNumber}`,
    );
  };

  showContactForm = (contactId, mode, employerCodeNumber) => {
    hashHistory.push(`/client-manager/contact/${contactId}/${mode}/${employerCodeNumber}`);
  };

  closeForm() {
    this.setState({ showForm: false });
  }

  onFormCancel() {
    this.setState({ showForm: false });
  }

  onFormSubmit = (values) => {
    this.props
      .updateEvent(values, {
        tenantId: this.props.user.queryParams.tenantId,
        employerCodeNumber: this.props.params.employerCodeNumber,
      })
      .then((result) => {
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        } else {
          toast.success('Event has been saved.');
          this.setState({ showForm: false });
          this.props.getEvents(this.props.params.employerCodeNumber, {
            tenantId: this.props.user.queryParams.tenantId,
          });
          this.props.getEscalations(this.props.params.employerCodeNumber, {
            tenantId: this.props.user.queryParams.tenantId,
          });
        }
      });
  };

  deleteEvent = (meetingId) => {
    this.props
      .deleteEvent(meetingId, {
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then(() =>
        this.props.getEvents(this.props.params.employerCodeNumber, {
          tenantId: this.props.user.queryParams.tenantId,
        }),
      );
  };

  deleteEscalation = (escalationId) => {
    this.props
      .deleteEscalation(escalationId, {
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then(() =>
        this.props.getEscalations(this.props.params.employerCodeNumber, {
          tenantId: this.props.user.queryParams.tenantId,
        }),
      );
  };

  removeFileFromUploadList(fileName) {
    this.setState({
      files: this.state.files.filter((file) => file.name !== fileName),
    });
  }

  onStartUpload() {
    this.props
      .uploadFiles(
        this.props.params.employerCodeNumber,
        {
          tenantId: this.props.user.queryParams.tenantId,
        },
        this.state.files,
      )
      .then((result) => {
        if (result.error) {
          const message = _.get(result, 'payload.response.error.message', null);
          if (message) {
            toast.error(message);
          } else {
            toast.error('Something went wrong. Try again later.');
          }
        } else {
          toast.success('Files have been uploaded.');
          this.setState({ showUpload: false, files: [] });
          this.props.getFiles(this.props.params.employerCodeNumber, {
            tenantId: this.props.user.queryParams.tenantId,
          });
        }
      });
  }

  downloadFile(fileName) {
    this.props
      .getClientFile(
        this.props.params.employerCodeNumber,
        {
          tenantId: this.props.user.queryParams.tenantId,
        },
        fileName,
      )
      .then((response) => {
        const blob = response.payload;
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      });
  }

  previewFile(filename) {
    this.props
      .previewFile(
        this.props.params.employerCodeNumber,
        {
          tenantId: this.props.user.queryParams.tenantId,
        },
        filename,
      )
      .then((response) => {
        const blob = response.payload;
        var type = filename.substring(
          filename.lastIndexOf('.') + 1,
          filename.length,
        );
        this.setState({ fileName: URL.createObjectURL(blob) });
        this.setState({ fileType: type });
        this.setState({ showPreview: true });
      });
  }

  closePreview() {
    this.setState({ showPreview: false });
  }

  deleteFile(fileName) {
    this.props
      .deleteClientFile(
        this.props.params.employerCodeNumber,
        {
          tenantId: this.props.user.queryParams.tenantId,
        },
        fileName,
      )
      .then((result) => {
        if (result.error) {
          const message = _.get(result, 'payload.response.error.message', null);
          if (message) {
            toast.error(message);
          } else {
            toast.error('Something went wrong. Try again later.');
          }
        } else {
          toast.success('File has been deleted.');
          this.props.getFiles(this.props.params.employerCodeNumber, {
            tenantId: this.props.user.queryParams.tenantId,
          });
        }
      });
  }

  updateFileInfo(fileName, data, otherAttrs) {
    const newInfo = {
      tags: otherAttrs.tags,
      title: otherAttrs.title,
      description: otherAttrs.description,
      categoryId: otherAttrs.categoryId,
      isShared: otherAttrs.isShared,
      ...data,
    };
    this.props
      .updateClientFileInfo(
        this.props.params.employerCodeNumber,
        fileName,
        {
          tenantId: this.props.user.queryParams.tenantId,
        },
        newInfo,
      )
      .then((result) => {
        if (result.error) {
          const message = _.get(result, 'payload.response.error.message', null);
          if (message) {
            toast.error(message);
          } else {
            toast.error('Something went wrong. Try again later.');
          }
        } else {
          toast.success('File has been updated.');
          this.props.getFiles(this.props.params.employerCodeNumber, {
            tenantId: this.props.user.queryParams.tenantId,
          });
        }
      });
  }

  renderEditable(cellInfo) {
    return (
      <div
        style={{ backgroundColor: 'rgba(255,255,255,0)' }}
        contentEditable={!isExecutive}
        suppressContentEditableWarning
        onBlur={(e) => {
          const text = $('<p/>').html(e.target.innerHTML).text();
          this.updateFileInfo(
            cellInfo.original.fileName,
            {
              [cellInfo.column.id]: text,
            },
            cellInfo.original,
          );
        }}
        dangerouslySetInnerHTML={{
          __html: cellInfo.original[cellInfo.column.id],
        }}
      />
    );
  }

  renderEditableTags(cellInfo) {
    return (
      <div
        style={{ backgroundColor: 'rgba(255,255,255,0)' }}
        contentEditable={!isExecutive}
        suppressContentEditableWarning
        onBlur={(e) => {
          const text = $('<p/>').html(e.target.innerHTML).text();
          this.updateFileInfo(
            cellInfo.original.fileName,
            {
              [cellInfo.column.id]: text.split(','),
            },
            cellInfo.original,
          );
        }}
        dangerouslySetInnerHTML={{
          __html: cellInfo.original[cellInfo.column.id]
            ? cellInfo.original[cellInfo.column.id].join()
            : '',
        }}
      />
    );
  }

  renderEditableCategory(cellInfo) {
    const { categories } = this.props.data;
    return (
      <div>
        <select disabled={this.props.isExecutive} className="form-control" value={cellInfo.original.categoryId ? cellInfo.original.categoryId : ''} onChange={(e) => {
          this.updateFileInfo(
            cellInfo.original.fileName,
            {
              categoryId: e.target.value,
            },
            cellInfo.original,
          );
        }}>
          <option value="">Select</option>
          {categories && categories.map((category, index) => (
            <option key={index} value={category.id}>{category.name}</option>
          ))}
        </select>
      </div>
    );
  }

  renderEditableShared(cellInfo) {
    return (
      <div>
        <select disabled={this.props.isExecutive} className="form-control" value={cellInfo.original.isShared} onChange={(e) => {
          this.updateFileInfo(
            cellInfo.original.fileName,
            {
              isShared: e.target.value,
            },
            cellInfo.original,
          );
        }}>
          <option value="false">No</option>
          <option value="true">Yes</option>
        </select>
      </div>
    );
  }

  render() {
    const {
      data: { client, files, isFilesLoading, isFilesUploading, isFileUpdating },
      comments,
      user,
      params: { employerCodeNumber },
      meetingtypes,
      escalationtypes,
      events,
      escalations,
      clientlocations,
      contacts,
      isExecutive,
      isStaff
    } = this.props;

    const meetingTypesOptions =
      meetingtypes.data &&
      meetingtypes.data.map((item) => ({
        value: item.id,
        label: item.type,
      }));
    const escalationTypesOptions =
      escalationtypes.data &&
      escalationtypes.data.map((item) => ({
        value: item.id,
        label: item.type,
      }));

    const filesToUpload = this.state.files.map((file) => (
      <li className="list-group-item" key={file.name}>
        <span className="filename">{file.name}</span>
        <a
          className="action btn btn-xs btn-danger"
          onClick={() => this.removeFileFromUploadList(file.name)}
        >
          <i className="fa fa-close" />
        </a>
        <span className="badge">{humanFileSize(file.size)} bytes</span>
      </li>
    ));

    const acceptedFiles =
      'image/jpeg, image/png, image/gif, image/x-icon, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-powerpoint, application/vnd.oasis.opendocument.text, application/vnd.ms-excel, application/x-photoshop, audio/mpeg, audio/x-m4a, application/ogg, video/mp4, video/mpeg4, video/x-m4v, video/quicktime, video/x-ms-wmv, video/avi, video/mpeg, video/ogg, video/3gpp, video/3gpp2';

    const hasChildren = client.childs && client.childs.length > 0;
    const hasParent = client && client.parent;

    let relatedClients = [];
    if (hasChildren) {
      relatedClients = client.childs.map((e, index) => (
        <React.Fragment key={index}>
          <Link
            className="btn btn-default btn-xs"
            to={`client-manager/detail/${e.code}`}
          >
            <i className="fa fa-eye"></i> {e.name}
          </Link>
          &nbsp;
        </React.Fragment>
      ));
      relatedClients.unshift(
        <React.Fragment>
          <strong>Children Clients:</strong>{' '}
        </React.Fragment>,
      );
    } else if (hasParent) {
      relatedClients.push(
        <React.Fragment>
          <strong>Parent Client:</strong>{' '}
        </React.Fragment>,
      );
      relatedClients.push(
        <React.Fragment>
          <Link
            className="btn btn-default btn-xs"
            to={`client-manager/detail/${client.parent.code}`}
          >
            <i className="fa fa-eye"></i> {client.parent.name}
          </Link>
          &nbsp;
        </React.Fragment>,
      );
    }
    return (
      <div id="content">
        {client.employerCodeNumber && (
          <Helmet title={`${client.employerCodeNumber} – ${hostTitle()}`} />
        )}
        <BigBreadcrumbs
          items={[
            'Administration',
            { title: 'Client Manager', route: '/client-manager' },
            'Detail',
          ]}
          icon="fa fa-fw fa-database"
          className=""
        />

        <WidgetGrid>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="product-content product-wrap clearfix product-deatil">
                {this.props.data.isLoading && <div className="cover"></div>}
                {client.employerCodeNumber && (
                  <div className="row">
                    <div className="col-md-12">
                      <button disabled={isStaff || isExecutive}
                        className="btn btn-primary pull-right"
                        onClick={() =>
                          this.editClient(client.employerCodeNumber)
                        }
                      >
                        <i className="fa fa-pencil" />
                      </button>
                      <h2 className="name">
                        {client.employerCodeNumber} |{' '}
                        {client.employerCodeDescription}
                        <small>Employer Code: {client.employerCode}</small>
                        <small>
                          Group: {client.groupName} | Group Number:{' '}
                          {client.groupNumber}
                        </small>
                        <span className="fa fa-2x">
                          <h5>Last Updated at: {client.updatedAt}</h5>
                        </span>
                      </h2>
                      <hr className="simple" />
                    </div>
                    <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12">
                      <h3 className="price-container">
                        {client.primaryClinic} <small>Primary Clinic</small>
                      </h3>
                      <div className="certified">
                        <ul>
                          <li>
                            <a>
                              Eligible Employees
                              <span>{client.eligibleEmployees}</span>
                            </a>
                          </li>
                          <li>
                            <a>
                              Total Enrollment
                              <span>{client.totalEnrollment}</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="description description-tabs">
                        <ul id="myTab" className="nav nav-tabs">
                          <li className="active">
                            <a
                              href="#information"
                              data-toggle="tab"
                              className="no-margin"
                            >
                              Client Information{' '}
                            </a>
                          </li>
                          <li className="">
                            <a href="#billing" data-toggle="tab">
                              Billing
                            </a>
                          </li>
                          <li className="">
                            <a href="#event" data-toggle="tab">
                              Event
                            </a>
                          </li>
                          <li className="">
                            <a href="#escalation" data-toggle="tab">
                              Escalation
                            </a>
                          </li>
                          <li className="">
                            <a href="#team" data-toggle="tab">
                              Team
                            </a>
                          </li>
                          <li className="">
                            <a href="#healthcentres" data-toggle="tab">
                              Health Centers
                            </a>
                          </li>
                          <li className="">
                            <a href="#locations" data-toggle="tab">
                              Locations
                            </a>
                          </li>
                          <li className="">
                            <a href="#contacts" data-toggle="tab">
                              Contacts
                            </a>
                          </li>
                        </ul>
                        <div id="myTabContent" className="tab-content">
                          <div
                            className="tab-pane fade active in"
                            id="information"
                          >
                            <div className="certified">
                              <ul>
                                <li>
                                  <a>
                                    Status<span>{client.status}&nbsp;</span>
                                  </a>
                                </li>
                                <li>
                                  <a>
                                    Start Date
                                    <span>
                                      <Moment
                                        date={client.startDate}
                                        format="MM/DD/YYYY"
                                      />
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a>
                                    Renewal Date
                                    <span>
                                      <Moment
                                        date={client.renewalDate}
                                        format="MM/DD/YYYY"
                                      />
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a>
                                    VI Share<span>{client.viShare}&nbsp;</span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <br />
                            <strong>
                              About {client.employerCodeDescription}{' '}
                            </strong>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: client.employerAbout,
                              }}
                            />
                            <br />
                            <div>{relatedClients}</div>
                            <br />
                            <dl className="">
                              <dt>Address</dt>
                              <dd>
                                {client.address1}, {client.address2},{' '}
                                {client.city}, {client.state} {client.zip}{' '}
                              </dd>
                              <dd>
                                {client.phone1} <small> Main</small>
                              </dd>
                              <dd>
                                {client.fax1} <small> Fax</small>
                              </dd>
                              <br />

                              <dt>Primary Contact Person</dt>
                              <dd>
                                {client.primaryContactFName}{' '}
                                {client.primaryContactLName}{' '}
                              </dd>
                              <dd>{client.primaryContactPhone1} </dd>
                              <dd>{client.primaryContactEmail} </dd>
                              <br />

                              <dt>Secondary Contact</dt>
                              <dd>
                                {client.secondaryContactFName}{' '}
                                {client.secondaryContactLName}{' '}
                              </dd>
                              <dd>{client.secondaryContactPhone1} </dd>
                              <dd>{client.secondaryContactEmail} </dd>
                            </dl>
                          </div>
                          
                          <div className="tab-pane fade" id="billing">
                            <br />
                            <dl className="">
                              <dt>Billing Details</dt>
                              <dd
                                dangerouslySetInnerHTML={{
                                  __html: client.employerBillingDescriptionText,
                                }}
                              />
                            </dl>
                          </div>
                          <div className="tab-pane fade" id="event">
                            <br />
                            <button disabled={isStaff || isExecutive}
                              className="btn btn-default"
                              onClick={() => this.showEventForm(0)}
                            >
                              <i className="fa fa-plus" /> Add Meeting Event
                            </button>
                            <dl className="">
                              <br />
                              <dt>Event Details</dt>
                              <ReactTable
                                ref={(instance) => {
                                  this.table = instance;
                                }}
                                pageSize={10}
                                minRows={1}
                                loading={events.isEventLoading}
                                data={
                                  events && events.data && events.data.list
                                    ? events.data.list
                                    : []
                                }
                                columns={[
                                  {
                                    Header: '',
                                    id: 'actions',
                                    width: 60,
                                    sortable: false,
                                    Cell: (row) => (
                                      <span>
                                        <button disabled={isStaff || isExecutive}
                                          className="btn btn-default btn-xs"
                                          onClick={() =>
                                            this.showEventForm(
                                              row.original.meetingId,
                                            )
                                          }
                                        >
                                          <i className="fa fa-pencil" />
                                        </button>
                                        &nbsp;
                                        <button disabled={isStaff || isExecutive}
                                          className="btn btn-default btn-xs"
                                          onClick={() =>
                                            this.deleteEvent(
                                              row.original.meetingId,
                                            )
                                          }
                                        >
                                          <i className="fa fa-trash" />
                                        </button>
                                      </span>
                                    ),
                                  },
                                  {
                                    Header: 'Meeting Id',
                                    id: 'meetingId',
                                    accessor: 'meetingId',
                                    show: false,
                                  },
                                  {
                                    Header: 'Meeting Date',
                                    accessor: 'meetingDate',
                                    Cell: (row) => (
                                      <Moment
                                        date={row.original.meetingDate}
                                        format="MM/DD/YYYY HH:mm"
                                      />
                                    ),
                                  },
                                  {
                                    Header: 'Meeting Type',
                                    accessor: 'meetingType',
                                  },
                                  {
                                    Header: 'Rep',
                                    accessor: 'reps',
                                  },
                                  {
                                    Header: 'Plan',
                                    accessor: 'plan',
                                  },
                                  {
                                    Header: 'Recap',
                                    accessor: 'recap',
                                  },
                                  {
                                    Header: 'Overall Score',
                                    accessor: 'overallScore',
                                  },
                                  {
                                    Header: 'Client Concerns',
                                    accessor: 'clientConcerns',
                                  },
                                ]}
                                className="-striped -highlight"
                                onSearchChange={this.handleSearch}
                                sortable={true}
                                defaultSorted={[
                                  {
                                    id: 'meetingDate',
                                    desc: true,
                                  },
                                ]}
                              />
                            </dl>
                          </div>
                          <div className="tab-pane fade" id="escalation">
                            <br />
                            <button disabled={isStaff || isExecutive}
                              className="btn btn-default"
                              onClick={() =>
                                this.showEscalationForm(
                                  0,
                                  this.props.params.employerCodeNumber,
                                )
                              }
                            >
                              <i className="fa fa-plus" /> Add Escalation
                            </button>
                            <dl className="">
                              <br />
                              <dt>Escalation Details</dt>
                              <ReactTable
                                ref={(instance) => {
                                  this.table = instance;
                                }}
                                pageSize={10}
                                minRows={1}
                                loading={escalations.isEscalationLoading}
                                data={
                                  escalations &&
                                    escalations.data &&
                                    escalations.data.list
                                    ? escalations.data.list
                                    : []
                                }
                                columns={[
                                  {
                                    Header: '',
                                    id: 'actions',
                                    width: 60,
                                    sortable: false,
                                    Cell: (row) => (
                                      <span>
                                        <button disabled={isStaff || isExecutive}
                                          className="btn btn-default btn-xs"
                                          onClick={() =>
                                            this.showEscalationForm(
                                              row.original.escalationId,
                                              this.props.params
                                                .employerCodeNumber,
                                            )
                                          }
                                        >
                                          <i className="fa fa-pencil" />
                                        </button>
                                        &nbsp;
                                        <button disabled={isStaff || isExecutive}
                                          className="btn btn-default btn-xs"
                                          onClick={() =>
                                            this.deleteEscalation(
                                              row.original.escalationId,
                                            )
                                          }
                                        >
                                          <i className="fa fa-trash" />
                                        </button>
                                      </span>
                                    ),
                                  },
                                  {
                                    Header: 'Escalation Id',
                                    id: 'escalationId',
                                    accessor: 'escalationId',
                                    show: false,
                                  },
                                  {
                                    Header: 'Date Reported',
                                    accessor: 'dateReported',
                                    Cell: (row) => (
                                      <Moment
                                        date={row.original.dateReported}
                                        format="MM/DD/YYYY HH:mm"
                                      />
                                    ),
                                  },
                                  {
                                    Header: 'Issue Name',
                                    accessor: 'issueName',
                                  },
                                  {
                                    Header: 'Issue Type',
                                    accessor: 'issueType',
                                  },
                                  {
                                    Header: 'Assigned To',
                                    accessor: 'assignedToName',
                                  },
                                  {
                                    Header: 'Description',
                                    accessor: 'description',
                                  },
                                  {
                                    Header: 'Resolved',
                                    accessor: 'resolved',
                                  },
                                ]}
                                className="-striped -highlight"
                                onSearchChange={this.handleSearch}
                                sortable={true}
                                defaultSorted={[
                                  {
                                    id: 'dateReported',
                                    desc: true,
                                  },
                                ]}
                              />
                            </dl>
                          </div>
                          <div className="tab-pane fade" id="team">
                            <br />{' '}
                            <dl className="">
                              <dt>Sales Representative(s)</dt>
                              <dd>Sales Rep 1: {client.salesRep1} </dd>
                              <dd>Sales Rep 2: {client.salesRep2} </dd>
                              <dt>Client Relations Manager</dt>
                              <dd>
                                {client.clientManager
                                  ? client.clientManager.name
                                  : ''}{' '}
                              </dd>
                              <dt>Employer Admin Users</dt>
                              <dd>
                                <a>
                                  {client.primaryContactFName}{' '}
                                  {client.primaryContactLName} -{' '}
                                  {client.primaryContactEmail}
                                </a>
                              </dd>
                              <dd>
                                <a>
                                  {client.secondaryContactFName}{' '}
                                  {client.secondaryContactLName} -{' '}
                                  {client.secondaryContactEmail}
                                </a>
                              </dd>
                            </dl>
                          </div>

                          <div className="tab-pane fade" id="healthcentres">
                            <br />
                            <div className="table-responsive">
                              {client.clinicLocations && (
                                <table className="table table-bordered table-condensed">
                                  <thead>
                                    <tr>
                                      <th>Location</th>
                                      <th>Status</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {client.clinicLocations &&
                                      client.clinicLocations.map((el, i) => (
                                        <tr key={i}>
                                          <td>
                                            <Link
                                              to={`/location-manager/detail/${el.clinicLocationID}`}
                                            >
                                              {el.siteName}
                                            </Link>
                                          </td>
                                          <td>
                                            <em>
                                              {el.isDefault ? 'Default' : ''}
                                            </em>
                                            {` `}
                                            <em>
                                              {el.isAnchorTenant
                                                ? 'Anchor'
                                                : ''}
                                            </em>
                                          </td>
                                        </tr>
                                      ))}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          </div>

                          <div className="tab-pane fade" id="locations">
                            <br />
                            <button disabled={isStaff || isExecutive}
                              className="btn btn-default"
                              onClick={() => this.showLocationForm(0)}
                            >
                              <i className="fa fa-plus" /> Add Client Location
                            </button>
                            <dl className="">
                              <br />
                              <dt>Location Details</dt>
                              <ReactTable
                                ref={(instance) => {
                                  this.table = instance;
                                }}
                                pageSize={10}
                                minRows={1}
                                loading={
                                  clientlocations.isClientLocationLoading
                                }
                                data={
                                  clientlocations &&
                                    clientlocations.data &&
                                    clientlocations.data.list
                                    ? clientlocations.data.list
                                    : []
                                }
                                columns={[
                                  {
                                    Header: '',
                                    id: 'actions',
                                    width: 60,
                                    sortable: false,
                                    Cell: (row) => (
                                      <span>
                                        <button disabled={isStaff || isExecutive}
                                          className="btn btn-default btn-xs"
                                          onClick={() =>
                                            this.showLocationForm(
                                              row.original.clientLocationId,
                                            )
                                          }
                                        >
                                          <i className="fa fa-pencil" />
                                        </button>
                                        &nbsp;
                                        <button disabled={isStaff || isExecutive}
                                          className="btn btn-default btn-xs"
                                          onClick={() =>
                                            this.deleteLocation(
                                              row.original.clientLocationId,
                                            )
                                          }
                                        >
                                          <i className="fa fa-trash" />
                                        </button>
                                      </span>
                                    ),
                                  },
                                  {
                                    Header: 'Client Location Id',
                                    id: 'clientLocationId',
                                    accessor: 'clientLocationId',
                                  },
                                  {
                                    Header: 'Site Code',
                                    accessor: 'siteCode',
                                  },
                                  {
                                    Header: 'Site Description',
                                    accessor: 'siteDescription',
                                  },
                                  {
                                    Header: 'Site Name',
                                    accessor: 'siteName',
                                  },
                                  {
                                    Header: 'Practice Group Name',
                                    accessor: 'practiceGroupName',
                                  },
                                  {
                                    Header: 'Phone Number',
                                    accessor: 'phoneNumber',
                                  },
                                  {
                                    Header: 'Latitude',
                                    accessor: 'latitude',
                                  },
                                  {
                                    Header: 'Longitude',
                                    accessor: 'longitude',
                                  },
                                ]}
                                className="-striped -highlight"
                                onSearchChange={this.handleSearch}
                                sortable={true}
                              />
                            </dl>
                          </div>

                          <div className="tab-pane fade" id="contacts">
                            <br />
                            <button disabled={isStaff || isExecutive}
                              className="btn btn-default"
                              onClick={() =>
                                this.showContactForm('00000000-0000-0000-0000-000000000000', 'Add', this.props.params.employerCodeNumber)
                              }
                            >
                              <i className="fa fa-plus" /> Add Contact
                            </button>
                            <br/>
                            <ReactTable
                              ref={(instance) => {
                                this.table = instance;
                              }}
                              pageSize={10}
                              minRows={1}
                              loading={contacts.isLoading}
                              data={contacts && contacts.data && contacts.data.list ? contacts.data.list : []
                              }
                              onFetchData={this.fetchData}
                              defaultSorted={[
                                {
                                  id: 'contactName',
                                  desc: false,
                                },
                              ]}
                              columns={[
                                {
                                  Header: '',
                                  id: 'actions',
                                  width: 50,
                                  sortable: false,
                                  Cell: (row) => (
                                    <span>
                                      <button disabled={isExecutive}
                                        className="btn btn-default btn-xs"
                                        onClick={() =>
                                          this.showContactForm(
                                            row.original.contact.id, 'Edit', this.props.params.employerCodeNumber
                                          )
                                        }
                                      >
                                        <i className="fa fa-pencil" />
                                      </button>
                                    </span>
                                  ),
                                },
                                {
                                  Header: 'ID',
                                  id: 'id',
                                  accessor: 'id',
                                  show: false,
                                },
                                {
                                  Header: 'Contact',
                                  id: 'contact.contactName',
                                  accessor: 'contact.contactName',
                                  Cell: (row) => (
                                    <a
                                      onClick={() =>
                                        this.showContactForm(
                                          row.original.contact.id, 'ReadOnly', this.props.params.employerCodeNumber
                                        )
                                      }
                                    >
                                      {row.original.contact.contactName}
                                    </a>
                                  ),
                                },
                                {
                                  Header: 'Company',
                                  id: 'contact.company',
                                  accessor: 'contact.company',
                                },
                                {
                                  Header: 'Phone',
                                  id: 'contact.phone1',
                                  accessor: 'contact.phone1',
                                },
                                {
                                  Header: 'Email',
                                  id: 'contact.email1',
                                  accessor: 'contact.email1',
                                },
                                {
                                  Header: 'Website',
                                  id: 'contact.website',
                                  accessor: 'contact.website',
                                },
                                {
                                  Header: 'Description',
                                  id: 'contact.description',
                                  accessor: 'contact.description',
                                },
                              ]}
                              className="-striped -highlight"
                              onSearchChange={this.handleSearch}
                            />
                          </div>

                        </div>
                      </div>
                      <hr />
                      <br />
                      <h3>
                        Files{' '}
                        <button disabled={isExecutive}
                          className="btn btn-default"
                          onClick={this.showModal.bind(this)}
                        >
                          <i className="fa fa-plus" /> Add Files
                        </button>
                      </h3>
                      <br />
                      <Modal
                        show={this.state.showLocationForm}
                        dialogClassName="modal-lg"
                      >
                        <Modal.Header>
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-hidden="true"
                            onClick={this.closeLocationForm.bind(this)}
                          >
                            &times;
                          </button>
                          <h4 className="modal-title">Add Client Location</h4>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="widget-body">
                            {
                              <ClientLocationsForm
                                onSubmit={this.onLocationFormSubmit}
                                onCancel={this.closeLocationForm.bind(this)}
                              />
                            }
                          </div>
                        </Modal.Body>
                      </Modal>

                      <Modal show={this.state.showUpload}>
                        <Modal.Header>
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-hidden="true"
                            onClick={this.closeModal.bind(this)}
                          >
                            &times;
                          </button>
                          <h4 className="modal-title" id="addFilesModalLabel">
                            Add Files
                          </h4>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="row client-files-upload">
                            <div
                              className={
                                this.state.files.length > 0
                                  ? 'col-sm-12'
                                  : 'col-sm-12'
                              }
                            >
                              <Dropzone
                                accept={acceptedFiles}
                                onDrop={this.onDrop.bind(this)}
                                onFileDialogCancel={this.onCancel.bind(this)}
                              >
                                {({
                                  getRootProps,
                                  getInputProps,
                                  isDragActive,
                                }) => {
                                  return (
                                    <div
                                      {...getRootProps()}
                                      className={classNames(
                                        'dropzone dropzone-client-files',
                                        { 'dropzone--isActive': isDragActive },
                                      )}
                                    >
                                      <input {...getInputProps()} />
                                      {isDragActive ? (
                                        <p>Drop files here...</p>
                                      ) : (
                                        <span className="text-center">
                                          <span className="font-lg visible-xs-block visible-sm-block visible-lg-block">
                                            <span className="font-lg">
                                              Drop files{' '}
                                              <span className="font-xs">
                                                to upload
                                              </span>
                                            </span>
                                            <span>
                                              &nbsp;&nbsp;
                                              <h4 className="display-inline">
                                                {' '}
                                                (Or Click)
                                              </h4>
                                            </span>
                                          </span>
                                        </span>
                                      )}
                                    </div>
                                  );
                                }}
                              </Dropzone>
                            </div>
                            {this.state.files.length > 0 && (
                              <div className="col-sm-12">
                                <h4>Files to be uploaded</h4>
                                <ul className="list-group files-upload-list">
                                  {filesToUpload}
                                </ul>
                                {` `}
                                {/* {this.state.files.length > 0 && <button className="btn btn-default" onClick={this.onCancel.bind(this)}>Clear</button>}{` `} */}
                              </div>
                            )}
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <button
                            type="button"
                            className="btn btn-default"
                            data-dismiss="modal"
                            onClick={this.closeModal.bind(this)}
                            disabled={isFilesUploading}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary"
                            disabled={this.state.files.length === 0}
                            onClick={this.onStartUpload.bind(this)}
                          >
                            Upload Files
                          </button>
                        </Modal.Footer>
                        {isFilesUploading && (
                          <div className="cover">
                            <div className="spinner" />
                          </div>
                        )}
                      </Modal>
                      <div
                        className="modal fade"
                        id="addFilesModal"
                        tabIndex="-1"
                        role="dialog"
                        aria-labelledby="addFilesModalLabel"
                        aria-hidden="true"
                      >
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-header" />
                            <div className="modal-body" />
                            <div className="modal-footer" />
                          </div>
                          {/* /.modal-content */}
                        </div>
                        {/* /.modal-dialog */}
                      </div>
                      {/* /.modal */}

                      <Modal
                        show={this.state.showForm}
                        dialogClassName="modal-lg"
                      >
                        <Modal.Header>
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-hidden="true"
                            onClick={this.closeForm.bind(this)}
                          >
                            &times;
                          </button>
                          <h4 className="modal-title">Add Meeting Event</h4>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="widget-body">
                            {
                              <EventForm
                                onSubmit={this.onFormSubmit}
                                onCancel={this.onFormCancel.bind(this)}
                                meetingtypes={meetingTypesOptions}
                                escalationtypes={escalationTypesOptions}
                                searchUsers={this.searchUsers}
                              />
                            }
                          </div>
                        </Modal.Body>
                      </Modal>

                      <ReactTable
                        ref={(instance) => {
                          this.table = instance;
                        }}
                        loading={
                          isFilesLoading || isFileUpdating || isFilesUploading
                        }
                        minRows={1}
                        data={
                          files[employerCodeNumber]
                            ? files[employerCodeNumber]
                            : []
                        }
                        columns={[
                          {
                            Header: 'Actions',
                            Cell: (row) => (
                              <div>
                                <button disabled={isExecutive}
                                  className="btn btn-xs btn-default"
                                  onClick={() =>
                                    this.downloadFile(row.original.fileName)
                                  }
                                >
                                  <i className="fa fa-download" />
                                </button>
                                {` `}
                                <button disabled={isExecutive}
                                  className="btn btn-xs btn-default"
                                  onClick={() =>
                                    this.previewFile(row.original.fileName)
                                  }
                                >
                                  <i className="fa fa-file" />
                                </button>
                                {` `}
                                <button disabled={isExecutive}
                                  className="btn btn-xs btn-danger"
                                  onClick={() =>
                                    this.deleteFile(row.original.fileName)
                                  }
                                >
                                  <i className="fa fa-remove" />
                                </button>
                              </div>
                            ),
                          },
                          {
                            Header: 'File',
                            accessor: 'fileName',
                          },
                          {
                            Header: 'Title',
                            accessor: 'title',
                            Cell: this.renderEditable,
                          },
                          {
                            Header: 'Description',
                            accessor: 'description',
                            Cell: this.renderEditable,
                          },
                          {
                            Header: 'Tags',
                            accessor: 'tags',
                            Cell: this.renderEditableTags,
                          },
                          {
                            Header: 'Category',
                            accessor: 'categoryId',
                            Cell: this.renderEditableCategory,
                          },
                          {
                            Header: 'Shared',
                            accessor: 'isShared',
                            Cell: this.renderEditableShared,
                          },
                          {
                            Header: 'Uploaded at',
                            accessor: 'uploadAt',
                            Cell: (row) => (
                              <Moment
                                date={row.original.uploadAt}
                                format="MM/DD/YYYY hh:mm"
                              />
                            ),
                          },
                          {
                            Header: 'Uploaded By',
                            accessor: 'uploadByEmail',
                          },
                        ]}
                        className="-striped -highlight"
                        onSearchChange={this.handleSearch}
                      />
                      <hr className="simple" />
                    </div>
                    {/*Comments Section*/}
                    <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12 ">
                      <CommentForm isExecutive={isExecutive} onSubmit={this.onSubmit} parentId={null} />
                      {comments.isLoading && <div className="spinner" />}
                      <Comments isExecutive={isExecutive}
                        comments={
                          comments && comments.data && comments.data.list
                            ? comments.data.list
                            : []
                        }
                        userid={user.data.id}
                        onUpdateSubmit={this.onUpdateSubmit}
                        onDeleteSubmit={this.onDeleteSubmit}
                        onSubmit={this.onSubmit}
                      />
                    </div>

                    <Modal
                      show={this.state.showPreview}
                      dialogClassName="modal-lg"
                    >
                      <Modal.Header>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-hidden="true"
                          onClick={this.closePreview.bind(this)}
                        >
                          &times;
                        </button>
                        <h4 className="modal-title">File Viewer</h4>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="widget-body">
                          {
                            <FileViewer
                              fileType={this.state.fileType}
                              filePath={this.state.fileName}
                            />
                          }
                        </div>
                      </Modal.Body>
                    </Modal>
                  </div>
                )}
              </div>
            </div>
          </div>
        </WidgetGrid>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    data: state.clientmanager,
    comments: state.comments,
    user: state.currentUser,
    users: state.users,
    meetingtypes: state.meetingtypes,
    escalationtypes: state.escalationtypes,
    events: state.eventmanager,
    escalations: state.escalationmanager,
    clientlocations: state.clientlocationmanager,
    contacts: state.contactmanager,
    isStaff: isStaff(state),
    isExecutive: isExecutive(state),
  }),
  (dispatch) => ({
    getClient: (employerCodeNumber, params) =>
      dispatch(requestClient(employerCodeNumber, params)),
    getComments: (employerCodeNumber, params) =>
      dispatch(requestClientComments(employerCodeNumber, params)),
    getFiles: (employerCodeNumber, params) =>
      dispatch(requestClientFiles(employerCodeNumber, params)),
    uploadFiles: (employerCodeNumber, params, files) =>
      dispatch(uploadClientFiles(employerCodeNumber, params, files)),
    getClientFile: (employerCodeNumber, params, file) =>
      dispatch(getClientFile(employerCodeNumber, params, file)),
    previewFile: (employerCodeNumber, params, file) =>
      dispatch(previewFile(employerCodeNumber, params, file)),
    deleteClientFile: (employerCodeNumber, params, file) =>
      dispatch(deleteClientFile(employerCodeNumber, params, file)),
    updateClientFileInfo: (employerCodeNumber, file, params, data) =>
      dispatch(
        updateClientFileDescription(employerCodeNumber, file, params, data),
      ),
    addMessage: (message, params) =>
      dispatch(addClientComment(message, params)),
    updateMessage: (id, message, params) =>
      dispatch(updateClientComment(id, message, params)),
    deleteMessage: (id, params) => dispatch(deleteClientComment(id, params)),
    getCurrentUser: () => dispatch(requestUserInfo()),
    getEvent: (meetingId, params) => dispatch(requestEvent(meetingId, params)),
    updateEvent: (event, params) => dispatch(updateEvent(event, params)),
    deleteEvent: (meetingId, params) =>
      dispatch(deleteEvent(meetingId, params)),
    deleteEscalation: (escalationId, params) =>
      dispatch(deleteClientEscalation(escalationId, params)),
    getMeetingTypes: (params) => dispatch(requestMeetingTypes(params)),
    getEvents: (employerCodeNumber, params) =>
      dispatch(requestEvents(employerCodeNumber, params)),
    getUsersTypeahead: (params) => dispatch(requestUsersTypeahead(params)),
    getEscalationTypes: (params) => dispatch(requestEscalationTypes(params)),
    getEscalations: (employerCodeNumber, params) =>
      dispatch(requestClientEscalations(employerCodeNumber, params)),
    getClientLocations: (employerCodeNumber, params) =>
      dispatch(requestClientLocations(employerCodeNumber, params)),
    getClientLocation: (clientLocationId, params) =>
      dispatch(requestClientLocation(clientLocationId, params)),
    updateClientLocation: (location, params) =>
      dispatch(updateClientLocation(location, params)),
    getClientReportCategories: (params) =>
      dispatch(requestClientReportCategories(params)),
    getContacts: (employerCodeNumber, params) =>
      dispatch(requestClientContacts(employerCodeNumber, params)),
  }),
)(ClientManagerDetail);



// WEBPACK FOOTER //
// ./src/routes/administration/containers/ClientManagerDetail.js